import { gridPaths } from '@/shared/hooks';
import { createFeatureGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchFeaturesGrid } from './gridQuery';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { FeatureDto } from '@flowqa/shared';

export const featuresGridConfig = ({
  projectId,
  organisationId,
  fixedFilters,
  initialSortModel,
  initialFilterModel,
  persistKey,
  syncStateToUrl = false,
}: {
  projectId?: string | null;
  organisationId?: string | null;
  fixedFilters?: GridQueryInput['filters'];
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  syncStateToUrl?: boolean;
} = {}): GridConfig<FeatureDto> =>
  createFeatureGridConfig<FeatureDto>(
    {
      path: gridPaths.features,
      queryFn: async (input) => await fetchFeaturesGrid(projectId, organisationId, input),
      noRowsText: 'No features found',
      defaultPersistKey: 'features',
      defaultSortModel: [{ field: 'name', sort: 'asc' }],
    },
    { fixedFilters, initialSortModel, initialFilterModel, persistKey, syncStateToUrl },
  );

export type FeaturesGridConfig = ReturnType<typeof featuresGridConfig>;
